import React from "react";
import { User, ShieldCheck, Lock, Key, Loader2 } from "lucide-react";

const AccountSettings = ({ isEditMode, SettingGroup, isSidebarOpen, userData, isLoading }) => {
  // Jika masih loading fetch data dari API
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[300px]">
        <Loader2 className="animate-spin text-blue-600" size={32} />
      </div>
    );
  }

  return (
    <div className={`grid gap-6 w-full ${isSidebarOpen ? "grid-cols-1" : "grid-cols-1 xl:grid-cols-2"}`}>
      <SettingGroup title="Personal Information" icon={User}>
        <div className="space-y-4">
          {/* Avatar Preview */}
          <div className="flex items-center gap-4 mb-4">
             <img 
               src={userData?.image} 
               alt="Profile" 
               className="w-16 h-16 rounded-2xl object-cover border-2 border-stone-100"
             />
             <div>
               <p className="text-xs font-bold text-stone-800 uppercase">{userData?.role}</p>
               <p className="text-[10px] text-stone-400">Member since {userData?.joined}</p>
             </div>
          </div>

          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Full Name</label>
            <input 
              type="text" 
              disabled={!isEditMode} 
              defaultValue={userData?.name} 
              className={`w-full px-4 py-2.5 border rounded-xl text-sm outline-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`} 
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Email Address</label>
            <input 
              type="text" 
              disabled={true} 
              value={userData?.email} 
              className="w-full px-4 py-2.5 bg-stone-100 border-transparent text-stone-500 border rounded-xl text-sm outline-none cursor-not-allowed" 
            />
            <p className="text-[10px] text-stone-400 mt-1 italic">*Email cannot be changed</p>
          </div>
        </div>
      </SettingGroup>

      <SettingGroup title="Security" icon={ShieldCheck}>
        <div className="space-y-4">
          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">Current Password</label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" size={14} />
              <input 
                type="password" 
                disabled={!isEditMode} 
                defaultValue={userData?.password} // Menampilkan password dari mock
                className={`w-full pl-10 pr-4 py-2.5 border rounded-xl text-sm outline-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`} 
              />
            </div>
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] font-medium text-stone-500 uppercase tracking-wider">New Password</label>
            <div className="relative">
              <Key className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" size={14} />
              <input 
                type="password" 
                disabled={!isEditMode} 
                placeholder="Enter new password" 
                className={`w-full pl-10 pr-4 py-2.5 border rounded-xl text-sm outline-none transition-all ${isEditMode ? "bg-stone-50 border-stone-200 shadow-inner" : "bg-stone-100 border-transparent text-stone-500"}`} 
              />
            </div>
          </div>
        </div>
      </SettingGroup>
    </div>
  );
};

export default AccountSettings;